export default {
	'font': 'Bevan',
	'platform': 'Facebook',
	'background': 'campaigns/crpf2hrfjtvl6coit4b5',
	'colorOverlay': 'none',
	'phrase': 'I thought I would be richer by now',
	'textAlign': 'center',
	'fontSize': '5: Large',
	'isBold': false,
	'isItalic': false,
	'showLogo': false,
	'showHash': false,
	'showUrl': false
}


// WEBPACK FOOTER //
// ./src/data/_Default.js